/**
 * @Author: Anandp
 * @Date:   2024-11-21 14:38:58
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 22:07:08
 */
import axios from "axios";
import { Url } from "src/config";

let pendingHealthSurveyPromise = null;
let healthSurveyCache = null;
let cacheTimestamp = 0;

const executiveHealthResultsApi = {
  /**
   * API function to get results of executive health survey
   * @param {string} accessToken
   * @returns
   */
  getHealthSurveyResults: async (accessToken) => {
    const now = Date.now();
    if (healthSurveyCache && (now - cacheTimestamp < 5000)) {
      return healthSurveyCache;
    }
    if (pendingHealthSurveyPromise) {
      return pendingHealthSurveyPromise;
    }

    pendingHealthSurveyPromise = (async () => {
      try {
        const response = await axios.get(
          `${Url}/customer/dashboard/getExecutiveHealth`,
          {
            headers: {
              "access-token": accessToken,
            },
          }
        );
        healthSurveyCache = response.data;
        cacheTimestamp = Date.now();
        return response.data;
      } catch (error) {
        return error;
      } finally {
        pendingHealthSurveyPromise = null;
      }
    })();

    return pendingHealthSurveyPromise;
  },
  /**
   * API function to get data of each category of executive health survey
   * @param {string} accessToken
   * @param {number} categoryId
   * @returns
   */
  getCategoryData: async (accessToken, categoryId,inviteid) => {
    try {
      const response = await axios.get(
        `${Url}/customer/dashboard/executiveHealthCategory?category_id=${categoryId}&inviteId=${inviteid}`,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  /**
   * API to get BMI data
   * @param {string} accessToken
   * @returns
   */
  getBMIData: async (accessToken) => {
    try {
      const response = await axios.get(
        `${Url}/customer/dashboard/executivehealth/bmiResults`,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  getBMIDataCoachesCorner: async (accessToken, userId, tenantId) => {
    try {
      const response = await axios.get(
        `${Url}/customer/dashboard/executivehealth/bmiResultsforcoach?tenantId=${tenantId}&userId=${userId}`,
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
};

export default executiveHealthResultsApi;
